import { fromServerTime } from '@Common/Helpers/ServerTime';
import { isTypedObject } from './TypeGuard';
import { localizeProperty } from './localize';

const dateRegex = /^\[(-?\d+)]$/;

function parseServerDate(value: any): Date {
    if (typeof value === 'string') {
        const date = dateRegex.exec(value);
        if (date) {
            const dateTime = new Date(parseInt(date[1], 10));
            return fromServerTime(dateTime);
        }
    }
    return null;
}

function referenceRestore(): [(keeper: any, key: any, value: any) => any, (root: any) => any] {
    const refMap = new Map<string, { ref: { $id: string }; references: { keeper: any; key: any }[] }>();

    function parse(keeper: any, key: any, value: any): any {
        if (_.isNil(value)) {
            return value;
        }
        const refId = value.$id ?? value.$ref;
        if (refId) {
            const ref = refMap.get(refId) ?? { ref: null, references: [] };
            refMap.set(refId, ref);
            if (value.$id) {
                ref.ref = value;
            }
            if (value.$ref) {
                ref.references.push({ keeper, key });
            }
        }
        return value;
    }

    function restore(root: any): any {
        for (const { ref, references } of refMap.values()) {
            delete ref.$id;
            for (const { keeper, key } of references) {
                keeper[key] = ref;
            }
        }
        return root;
    }

    return [parse, restore];
}

export function parseJson(source: string, skipReferenceHandling: boolean = false): any {
    const [parse, restore] = referenceRestore();
    const returnObject = JSON.parse(source, function (this: any, key: string, value: any): any {
        const date = parseServerDate(value);
        if (date) {
            return date;
        }
        if (isTypedObject(this)) {
            value = localizeProperty(this, key, value);
        }
        if (skipReferenceHandling) {
            return value;
        }
        return parse(this, key, value);
    });
    return restore(returnObject);
}
